module.exports = __webpack_public_path__ + "static/envBG-6f97d97036dd98a5e0a28b1944ca8748.jpg";